module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/F15qVh/tc-custom/9781452110400.jpg?1712927284624",
      "alt": "This image is the cover for the book It's Lonely in the Modern World"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("It's Lonely in the Modern World\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This “satisfying send-up of a design primer . . . presents lessons in hostile faucetry, blinding fluorescents and vicious exposed ductwork.” —"), _c('i', [_vm._v("The New York Times")])]), _c('br'), _c('br'), _vm._v("True modernity requires much more than discipline, vision, and a willingness to live without upper kitchen cabinets. "), _c('i', [_vm._v("It’s Lonely in the Modern World")]), _vm._v(" outlines exactly what’s required to achieve sleek design and the requisite ennui. "), _c('br'), _c('br'), _vm._v("From the creators of the Unhappy Hipsters website, this essential guide is to hipsters what "), _c('i', [_vm._v("The Official Preppy Handbook")]), _vm._v(" was to prepsters. The authors advise on a number of topics. Readers will learn how to navigate the vast array of concrete finishes and plywood grades, accessorize with children and pets, and opine with authority on rooflines. Featuring detailed illustrations, beautifully staged photos, and helpful charts, this master manual is perfect for aspiring modernists, those who love them, and, of course, those who love to hate them.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Molly Jane Quinn, Jenna Talbott\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Molly Jane Quinn is a founder of Unhappyhipsters.com, which receives over 200,000 unique visitors weekly. She lives in Portland, Oregon.Jenna Talbott is a founder of Unhappyhipsters.com, which receives over 200,000 unique visitors weekly. She lives in Boston, Massachusetts.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0